// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"155":"982994c6","365":"ba5af6f9","387":"94a899b8","397":"4aca6a03","398":"8e1b12fa","453":"74b21998","462":"f7c9a7b4","485":"43ac979a","604":"f784bea3","946":"77c128a4"}[chunkId] + ".chunk.js";
};